import {handleActions, Action} from 'redux-actions';
import {QCJobsListPayload} from 'QCWorkflow/QCManager/QCManagerTypes';
import {checkForNullAndFormat} from 'QCWorkflow/QCManager/Redux/QCManagerReducer';
import {
    FormattedRowType,
    DeliverySummaryResponse,
    DeliveryManagerState,
} from '../DeliveryManagerTypes';
import {
    DELIVERY_MANAGER_SUMMARY_SET,
    RESET_DELIVERY_JOBS,
    SET_DELIVERY_JOBS,
} from './DeliveryManagerAction';

const initialState: DeliveryManagerState = {
    isLoading: true,
    total: 0,
    rows: [
        {
            id: 0,
            status: '',
            startDate: '',
            finishDate: '',
            title: '',
            seriesTitle: '',
            contentType: '',
            contentPartner: '',
        },
    ],
    PENDING: 0,
    IN_PROGRESS: 0,
    COMPLETE: 0,
    FAILED: 0,
};

export const formatRow = (row: FormattedRowType) => {
    const {
        id,
        contentItemType: contentType,
        status,
        startDate,
        finishDate,
        title,
        seriesTitle,
        contentPartner,
        number,
        seasonNumber,
        displayTitle,
    } = row;

    const {partnerName} = contentPartner;

    return {
        id,
        displayTitle,
        contentType,
        status,
        startDate: checkForNullAndFormat(startDate),
        finishDate: checkForNullAndFormat(finishDate),
        title,
        seriesTitle,
        episodeNumber: number,
        seasonNumber,
        contentPartner: partnerName,
    };
};

export const setItems = (
    state: DeliveryManagerState,
    action: Action<QCJobsListPayload>
): DeliveryManagerState => {
    const {rows, total} = action.payload;

    if (rows)
        return {
            ...state,
            rows: rows.map(formatRow as any) as any,
            total,
            isLoading: false,
        };

    return state;
};

export const resetItems = (): DeliveryManagerState => {
    return initialState;
};

export const setSummary = (
    state: DeliveryManagerState,
    action: Action<DeliverySummaryResponse>
): DeliveryManagerState => ({
    ...state,
    ...action.payload,
});

const handlers = {
    [SET_DELIVERY_JOBS]: setItems,
    [RESET_DELIVERY_JOBS]: resetItems,
    [DELIVERY_MANAGER_SUMMARY_SET]: setSummary,
};

export default handleActions<DeliveryManagerState, any>(handlers, initialState);
